import Vue from "@/init";

const uri = "timeline{/id}";

var customActions = {};

const TimelineResource = Vue.resource(uri, {}, customActions);

export default TimelineResource;
